module.exports = __webpack_public_path__ + "img/image-preview.cbcb6b4f.jpg";